import React, { useCallback } from 'react';
import { CreateSigningAppointmentFormData } from '../../../04_confirmationStep/convertToCreateSigningAppointmentRequest';
import { useFormikContext } from 'formik';
import { INotesFormData } from './NotesForm';
import { attorneyOrNotary } from '../../../../../../../utilities/order/scheduling/attorneyOrNotary';
import { useDetermineNotesFormProps } from '../useDetermineNotesFormProps';

/* Allows the user to "skip" adding a notary.
 * Renders only on Notes forms that include a notary
 * "Saves" the form's notes
 */
export const AddNotaryLaterButton: React.FC<{
  advance: () => void;
  updatedWizardFormData: CreateSigningAppointmentFormData;
  setUpdatedWizardFormData: React.Dispatch<React.SetStateAction<CreateSigningAppointmentFormData>>;
}> = ({ advance, setUpdatedWizardFormData, updatedWizardFormData }) => {
  const { values, validateField } = useFormikContext<INotesFormData>();
  const { hasNotary } = useDetermineNotesFormProps(updatedWizardFormData);

  const handleSaveNotesAndAdvance = useCallback(() => {
    validateField('notes');
    setUpdatedWizardFormData((prevState) => ({ ...prevState, notes: values.notes }));
    advance();
  }, [advance, setUpdatedWizardFormData, validateField, values.notes]);

  if (!hasNotary) {
    return null;
  }
  return (
    <div className={'cursor-pointer'} onClick={handleSaveNotesAndAdvance}>
      {`Add ${attorneyOrNotary(updatedWizardFormData.signingMethod)} Later`}
    </div>
  );
};
